import * as stylex from "@stylexjs/stylex";
import useLocale from "hooks/useLocale";
import { lighten } from "lib/colorManipulator";
import { useState } from "react";
import { useActiveTheme } from "../hooks";
import { DEFAULT_LAYOUT, foldLayout, Layout } from "../materials";
import { colors } from "../materials/consts.stylex";
import { Grid } from "../materials/grid";
import { io, O, pipe } from "../prelude";
import { findArticleAlias, RAliasArticle, useAlias } from "../routes";
import { ArticleNavigation } from "./article-navigation";
import { Footer } from "./footer";
import { HeadMetaDynamic } from "./head-meta";
import { TOCContext } from "./hero-vis/TOC";
import { SiteHeader } from "./SiteHeader";
export const Frontmatter = io.intersection([
    io.type({
        title: io.string,
        lead: io.string
    }),
    io.partial({
        layout: Layout,
        year: io.number,
        article: RAliasArticle
    })
]);
export const mkAppLayout = (children)=>({ title, lead, layout = DEFAULT_LAYOUT })=>{
        const activeTheme = useActiveTheme();
        const [sections, setSections] = useState([]);
        const locale = useLocale();
        const alias = useAlias();
        const { verticalPadding, darkBackground } = foldLayout(layout, {
            home: ()=>({
                    verticalPadding: false,
                    darkBackground: false
                }),
            simple: ()=>({
                    verticalPadding: true,
                    darkBackground: false
                }),
            article: ()=>({
                    verticalPadding: false,
                    darkBackground: false
                }),
            articleNarrow: ()=>({
                    verticalPadding: false,
                    darkBackground: false
                }),
            full: ()=>({
                    verticalPadding: true,
                    darkBackground: true
                }),
            none: ()=>({
                    verticalPadding: false,
                    darkBackground: false
                }),
            explorer: ()=>({
                    verticalPadding: true,
                    darkBackground: false
                }),
            focus: ()=>({
                    verticalPadding: false,
                    darkBackground: false
                })
        });
        const bg = layout === "article" ? lighten(activeTheme.background.light, 0.9) : "white";
        const aliasRoute = pipe(findArticleAlias(alias), O.getOrElseW(()=>undefined));
        return <div className="x78zum5 xdt5ytf xg6iff7">
        <HeadMetaDynamic locale={locale} title={title} description={lead} pageType={layout === "article" || layout === "focus" ? "article" : "website"}/>

        <SiteHeader/>

        <main id="main" {...{
            0: {
                className: "xc8qplx x1jyiexg"
            },
            2: {
                className: "xc8qplx x10akkqq x1jyiexg"
            },
            1: {
                className: "xc8qplx x1jyiexg x2b8uid"
            },
            3: {
                className: "xc8qplx x10akkqq x1jyiexg x2b8uid"
            }
        }[!!verticalPadding << 1 | !!darkBackground << 0]} style={{
            "--main-bg": darkBackground ? colors.grayscale2 : bg
        }}>
          <TOCContext.Provider value={{
            ids: sections,
            addId: (x)=>{
                if (!sections.includes(x)) {
                    setSections([
                        ...sections,
                        x
                    ]);
                }
            },
            removeId: (x)=>{
                if (sections.includes(x)) {
                    setSections(sections.filter((d)=>d !== x));
                }
            }
        }}>
            <Grid layout={layout}>{children}</Grid>
          </TOCContext.Provider>

          {aliasRoute && <ArticleNavigation aliasRoute={aliasRoute}/>}
        </main>

        <Footer/>
      </div>;
    };
